// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToListModalStyles } from "@insite/content-library/Components/ManageShareListModal";
import { color, mergeWithCss } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

addToListModalStyles.modal = {
    size: 600,
    // XNG-Changes: fix flinching issue on safari
    cssOverrides: {
        modalContainer: css`
            animation: 0;
        `,
    },
};

addToListModalStyles.userTableHeaderText = {
    color: "common.white",
};

addToListModalStyles.inviteButton = {
    variant: "tertiary",
    css: css`
        margin-left: auto;
    `,
};
addToListModalStyles.userRemoveLink = {
    ...mergeWithCss(addToListModalStyles.userRemoveLink, {
        mergeCss: true,
        css: css`
            &,
            svg {
                &:hover {
                    color: ${color("common.ui8")};
                }
            }
        `,
    }),
};

addToListModalStyles.buttonsWrapper = {
    css: css`
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
    `,
};

addToListModalStyles.makePrivateButton = {
    variant: "tertiary",
};

addToListModalStyles.closeButton = {
    css: css`
        margin: 0;
    `,
};

addToListModalStyles.editingPermissionText = {
    css: css`
        display: inline-block;
        margin-bottom: 15px;
    `,
};

addToListModalStyles.editingPermissionRadioGroup = {
    ...mergeWithCss(addToListModalStyles.editingPermissionRadioGroup, {
        css: css`
            display: flex;
            justify-content: flex-start;
        `,
    }),
};
